/**
 * @see https://umijs.org/docs/max/access#access
 */

export default function access(
  initialState: { accessibleMenuPaths?: string[],currentUser:Record<string,any> } | undefined
  ) {
  const accessibleMenuPaths = initialState?.accessibleMenuPaths || [];
  const currentUser = initialState?.currentUser;
  
  //console.log('检查路由权限，可访问的菜单路径:', accessibleMenuPaths);
  //debugger;
  return {
    
    canAccess: (route) => {
      //debugger;
      //console.log('检查路由:', route);
      if(currentUser && currentUser.user_id === 'admin')
        return true;
      // 如果是登录页，返回 true
      if (route === '/user/login') return true;

      // 检查路由是否在可访问菜单路径中
      const hasAccess = accessibleMenuPaths.some((menuPath) => menuPath.includes(route.path));
      //console.log('路由', route, '是否有权限:', hasAccess);
      return hasAccess;
    },
  };
}
